import React, { FC, ReactElement, useMemo, useState } from 'react'
import { ButtonBase, Collapse } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { ServiceMessage } from '../../Organisms/WelcomeContainer/Types'
import { LanguageUtils } from '../../../../React/Common/Utils/LanguageUtils'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import Icon, { IconName } from '../../../../React/Common/Components/Icon'
import { Modal } from '../Modal/Modal'
import { useMessages } from '../../../Hooks/useMessages'
import { ReactState } from '../../../../React/Common/Types/Types'
import { usePersistentState } from '../../../../React/Common/Hooks/usePersistState'

export const ServiceMessages: FC = (): ReactElement => {
    const serviceMessages: Nullable<ServiceMessage[]> = useMessages()

    const [isMessageOpen, setIsMessageOpen]: ReactState<boolean> = useState<boolean>(false)
    const [closedMessages, setClosedMessages]: ReactState<string[]> = usePersistentState<string[]>(
        'closedMessageIDs',
        []
    )

    const currentMessageToDisplayID: Nullable<string> = useMemo(
        (): Nullable<string> =>
            serviceMessages?.find(({ id }: ServiceMessage): boolean => !closedMessages.includes(id ?? EMPTY_STRING))
                ?.id ?? null,
        [JSON.stringify(serviceMessages), JSON.stringify(closedMessages)]
    )

    const currentMessageToDisplay: Nullable<ServiceMessage> = useMemo(
        (): Nullable<ServiceMessage> =>
            serviceMessages?.find(({ id }: ServiceMessage): boolean => id === currentMessageToDisplayID) ?? null,
        [JSON.stringify(serviceMessages), currentMessageToDisplayID]
    )

    const closeMessage = (id: Nullable<string>): void => {
        setClosedMessages((closedMessagesLocal: string[]): string[] => [...closedMessagesLocal, id ?? EMPTY_STRING])
    }

    return (
        <div className='wc-service-messages'>
            {serviceMessages?.map(
                ({ id, popupMessage, type }: ServiceMessage): ReactElement => (
                    <Collapse key={id} in={id === currentMessageToDisplayID}>
                        <ButtonBase
                            className='wc-service-message-ripple'
                            onClick={(event: React.MouseEvent): void => {
                                if (!(event.target as HTMLElement).closest('.wc-service-message-close')) {
                                    setIsMessageOpen(true)
                                }
                            }}
                        >
                            <Alert className='wc-service-message' severity={type} variant='filled'>
                                <div className='wc-service-message-title'>
                                    {LanguageUtils.formatLanguageEntry(popupMessage)}
                                </div>
                                <div
                                    className='wc-service-message-close'
                                    onClick={(): void => closeMessage(id ?? EMPTY_STRING)}
                                >
                                    <Icon iconName={IconName.X} />
                                </div>
                            </Alert>
                        </ButtonBase>
                    </Collapse>
                )
            )}
            <Modal
                className='wc-service-message-modal'
                isOpen={isMessageOpen}
                onClose={(): void => {
                    setIsMessageOpen(false)
                    closeMessage(currentMessageToDisplayID)
                }}
            >
                <h3 className='wcsm-title'>
                    {LanguageUtils.formatLanguageEntry(currentMessageToDisplay?.popupMessage ?? EMPTY_STRING)}
                </h3>
                <div className='wcsm-content'>
                    {LanguageUtils.formatLanguageEntry(currentMessageToDisplay?.description ?? EMPTY_STRING)}
                </div>
            </Modal>
        </div>
    )
}
